import { Image, Text } from '@ui/atoms';
import { Button } from '@ui/atoms/design-system';

import FeatureList from '@components/Products/FixedDeposits/components/HeroSection/FeatureList';
import { fdRedirectTo } from '@components/Products/FixedDeposits/utils/utils';
import FdTexts from '@components/Products/FixedDeposits/en.json';
import useWindowDimensions from '@hooks/useWindowDimensions';
import { triggerCustomEvent } from '@helpers/miscelleanous';
import { fdProductEvents } from '@helpers/enums/gaEventNameEnum';
import { replaceKeysWithValues } from '@ui/helpers/string';

const texts = FdTexts.HeroSection;

const HeroContent = ({ toggleModal, maxInterest }) => {
    const { width } = useWindowDimensions();
    const isMobile = width < 768;
    const handleOnClick = () => {
        triggerCustomEvent(fdProductEvents.CLICKED_FD_PRODUCT_BOOK_NOW);

        isMobile ? fdRedirectTo() : toggleModal();
    };

    return (
        <div className="z-10 flex flex-col md:items-center md:gap-12">
            {/* Header Section */}
            <div className="flex flex-col items-center gap-4 md:gap-3">
                <Image
                    src={'/images/products/SafeIcon.svg'}
                    alt={texts.altText.safeIcon}
                    className="md:h-20 md:w-18 w-[66px] h-[74px]"
                />
                <div className="flex flex-col gap-1">
                    <div className="flex items-center gap-2">
                        <Image
                            src={'/images/products/Lightning.svg'}
                            alt={texts.altText.lightningIcon}
                        />

                        <Text
                            content={
                                <>
                                    <Text
                                        content={texts.prefix}
                                        className="hidden h3-regular text-basicWhite md:inline-block"
                                    />
                                    <Text
                                        content={texts.title}
                                        className="text-transparent h4-semibold md:h3-semibold bg-fd-text-gradient bg-clip-text whitespace-nowrap"
                                    />
                                    <Text
                                        content={texts.suffix}
                                        className="hidden h3-regular text-basicWhite md:inline-block whitespace-nowrap"
                                    />
                                </>
                            }
                            htmlTag="h1"
                            className="flex items-center gap-1"
                        />
                        <Image
                            src={'/images/products/Lightning.svg'}
                            alt={texts.title}
                        />
                    </div>
                    <Text
                        content={texts.description}
                        className="inline-block text-center h5-semibold text-basicWhite md:hidden"
                        htmlTag="p"
                    />
                </div>
                <Text
                    content={replaceKeysWithValues(texts.subDescription, { '{maxInterest}': maxInterest })}
                    className="text-center p5-regular md:p3-regular text-primary-10"
                    isInnerHtml
                    htmlTag="p"
                />
            </div>
            <FeatureList />
            <Button
                onClick={handleOnClick}
                buttonText={texts.button}
                buttonType="tertiary"
                className="mt-6 md:mt-0"
                widthClass="w-full md:w-auto"
            />
            <Text
                content={texts?.terms}
                className="absolute bottom-2 md:bottom-4 right-4 p7-regular text-primary-50"
                htmlTag="p"
            />
        </div>
    );
};

export default HeroContent;
